import { render, staticRenderFns } from "./PowerBI.vue?vue&type=template&id=69f64c96&"
import script from "./PowerBI.vue?vue&type=script&lang=js&"
export * from "./PowerBI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports